import { create } from "zustand";
import type { EexCapabilities, EexAccessOverrides, FinanceFunction, FinanceTab, UserRole } from "@chro/shared";

// EEX subscription summary sent on /auth/me for company users on the module.
// Optional/defensive — a stale cached payload may omit it (never assume presence).
export interface EexBillingSummary {
  status: string;
  tier: string;
  features: string[];
  traderSeats: { included: number | null; extra: number; used: number };
}

export interface AuthUser {
  userId: string;
  email: string;
  role: UserRole;
  companyId: string | null;
  companyName: string | null;
  displayName: string | null;
  mustChangePassword: boolean;
  hideIdentityInHeader: boolean;
  eexEnabled?: boolean;
  eexFinanceTabs?: FinanceTab[];
  eexFinanceFunctions?: FinanceFunction[];
  eexCapabilities?: EexCapabilities;
  eexAccessOverrides?: EexAccessOverrides;
  eexDatasourceEnabled?: boolean;
  tradingEnabled?: boolean;
  forecastingEnabled?: boolean;
  brmEnabled?: boolean;
  eexBilling?: EexBillingSummary;
}

interface AuthState {
  user: AuthUser | null;
  setUser(user: AuthUser | null): void;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
}));
